export type PaymentStatusValue = 'Opłacona' | 'Częściowo opłacona' | 'Nieopłacona' | 'Nadpłata';

export const normalizePaymentStatus = (
  status?: string
): PaymentStatusValue | (string & {}) => {
  const trimmed = (status ?? '').trim();
  if (trimmed.startsWith('Częściowo opłacona')) return 'Częściowo opłacona';
  if (trimmed.startsWith('Nadpłata')) return 'Nadpłata';
  return trimmed;
};

export const getPaymentStatusColor = (
  status?: PaymentStatusValue | string
): 'default' | 'warning' | 'success' | 'error' | 'info' => {
  const normalized = normalizePaymentStatus(status ?? '');
  if (!normalized || normalized === 'Nieopłacona') return 'error';
  if (normalized === 'Częściowo opłacona') return 'warning';
  if (normalized === 'Opłacona') return 'success';
  if (normalized === 'Nadpłata') return 'info';
  return 'default';
};

export const formatPaymentStatusLabel = (
  status: PaymentStatusValue | string,
  totalPrice: number,
  totalPaidAmount: number
): string => {
  const normalized = normalizePaymentStatus(status);
  if (normalized === 'Częściowo opłacona') {
    const remaining = Math.max(0, totalPrice - totalPaidAmount);
    return `Częściowo opłacona (${remaining.toFixed(2)} PLN)`;
  }
  if (normalized === 'Nadpłata') {
    const overpaid = Math.max(0, totalPaidAmount - totalPrice);
    return `Nadpłata (${overpaid.toFixed(2)} PLN)`;
  }
  return normalized || 'Nieopłacona';
};

export const getPaymentStatusAmount = (
  status: PaymentStatusValue | string,
  totalPrice: number,
  totalPaidAmount: number
): string | null => {
  const normalized = normalizePaymentStatus(status);
  if (normalized === 'Częściowo opłacona') {
    const remaining = Math.max(0, totalPrice - totalPaidAmount);
    return `${remaining.toFixed(2)} PLN`;
  }
  if (normalized === 'Nadpłata') {
    const overpaid = Math.max(0, totalPaidAmount - totalPrice);
    return `${overpaid.toFixed(2)} PLN`;
  }
  return null;
};
